import { useState } from 'react';

import { Trash2Icon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import Loading from '../../../feedback/loading.jsx';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../ui/alert-dialog';
import { Button } from '../../../ui/button';
import { Checkbox } from '../../../ui/checkbox.jsx';

export const DialogDeleteRecordConfirmation = ({
  button,
  action,
  recordName,
  redirect,
  message,
  disabled = false,
  alerts = true,
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  const handleDelete = async (event) => {
    event.preventDefault();

    setIsLoading(true);

    try {
      await action();

      if (redirect) {
        navigate(redirect);
      }

      alerts && toast.success('Registo eliminado com sucesso');
    } catch (err) {
      alerts && toast.error('Erro ao eliminar registo');
    }

    setOpen(false);
    setIsLoading(false);
  };

  const defaultDescription = (
    <span>
      O registo
      {recordName && <span className="font-bold"> - {recordName} - </span>}
      será eliminado permanentemente do sistema.
    </span>
  );

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button disabled={disabled} variant="destructive">
          <Trash2Icon />
          Eliminar
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        {isLoading ? (
          <div className="flex w-full justify-center">
            <Loading message="A eliminar registo" />
          </div>
        ) : (
          <>
            <AlertDialogHeader>
              <AlertDialogTitle>Tem a certeza?</AlertDialogTitle>

              <AlertDialogDescription>
                {message || defaultDescription}
              </AlertDialogDescription>

              <AlertDialogDescription className="font-bold text-red-500">
                Esta ação é irreversível.
              </AlertDialogDescription>
            </AlertDialogHeader>

            <div className="flex flex-row items-start space-x-2 py-4">
              <Checkbox
                id="confirm-delete"
                className="mt-0.5"
                checked={checked}
                onCheckedChange={setChecked}
              />
              <label
                htmlFor="confirm-delete"
                className="text-sm leading-none text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Eu concordo que esta ação tem consequências irreversíveis e que
                mesmo assim quero realizá-la.
              </label>
            </div>

            <AlertDialogFooter>
              <AlertDialogCancel>
                <XIcon />
                Cancelar
              </AlertDialogCancel>
              <Button
                disabled={!checked}
                variant="destructive"
                onClick={handleDelete}
              >
                <Trash2Icon />
                Eliminar
              </Button>
            </AlertDialogFooter>
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
};
